import styled from 'styled-components';
import { Card } from '../main/CommonStyles';

// Główny kontener siatki dla 3 kolumn
export const AvailabilityForm = styled.form`
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    align-items: stretch; /* Kluczowe dla równej wysokości kolumn */

    @media (min-width: 1200px) {
        /* Równy podział na 3 kolumny */
        grid-template-columns: repeat(3, 1fr);
    }

    .submit-container {
        grid-column: 1 / -1;
        display: flex;
        justify-content: flex-end;
        margin-top: 1rem;
    }

    label {
        display: block;
        font-weight: 600;
        margin-bottom: 1rem;
        color: ${({ theme }) => theme.colors.primaryDark};
        font-size: 1.1rem;
    }
`;

// Karta dla kolumny "Dodaj nowe"
export const AddSlotsCard = styled(Card)`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const TimeSlotter = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;

    input[type="time"], select {
        padding: 0.5rem;
        border-radius: ${({ theme }) => theme.borderRadius};
        border: 1px solid ${({ theme }) => theme.colors.borderColor};
        background-color: #fff;
        font-size: 0.9rem;
    }

    select {
        flex-grow: 1;
        min-width: 120px;
    }

    button {
        background: transparent;
        border: none;
        color: ${({ theme }) => theme.colors.danger};
        cursor: pointer;
        padding: 0.5rem;
        display: inline-flex;
        align-items: center;
        border-radius: 50%;
        margin-left: auto;
        &:hover {
            background-color: ${({ theme }) => theme.colors.dangerBg};
        }
    }
`;

// Karta dla kolumny z Kalendarzem
export const CalendarCard = styled(Card)`
    padding: ${({ theme }) => theme.spacing.md};
    height: 100%;

    .react-calendar {
        width: 100%;
        border: none;
        font-family: ${({ theme }) => theme.fonts.main};
    }

    .react-calendar__navigation button {
        color: ${({ theme }) => theme.colors.primary};
        min-width: 44px;
        background: none;
        font-size: 1rem;
        font-weight: 600;
        font-family: ${({ theme }) => theme.fonts.headings};
        margin-top: ${({ theme }) => theme.spacing.sm};
    }
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
        background-color: ${({ theme }) => theme.colors.primaryLightest};
    }
    .react-calendar__month-view__weekdays__weekday {
        text-align: center;
        font-weight: 500;
        font-size: 0.75rem;
        color: ${({ theme }) => theme.colors.textMedium};
        abbr {
            text-decoration: none;
        }
    }
    .react-calendar__tile {
        background: none;
        text-align: center;
        line-height: 2rem;
        font-size: 0.875rem;
        border-radius: ${({ theme }) => theme.borderRadius};
        transition: background-color 0.2s, color 0.2s;
        height: 48px;
        position: relative;
    }
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
        background-color: ${({ theme }) => theme.colors.primaryLightest};
        color: ${({ theme }) => theme.colors.primaryDark};
    }
    .react-calendar__tile--now {
        background: ${({ theme }) => theme.colors.secondaryLight + '4D'};
        color: ${({ theme }) => theme.colors.secondaryDark};
        font-weight: 600;
    }
    .react-calendar__tile--active {
        background: ${({ theme }) => theme.colors.primary};
        color: white;
        font-weight: 600;
    }
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
        background: ${({ theme }) => theme.colors.primaryDark};
    }
    .react-calendar__tile:disabled {
        background-color: #f1f5f9;
        color: #94a3b8;
        cursor: not-allowed;
        text-decoration: line-through;
        opacity: 0.7;
    }

    .dot {
        height: 6px;
        width: 6px;
        background-color: ${({ theme }) => theme.colors.secondaryDark};
        border-radius: 50%;
        position: absolute;
        bottom: 8px;
        left: 50%;
        transform: translateX(-50%);
    }
`;

// Karta dla kolumny "Zapisane Terminy"
export const SavedSlotsCard = styled(Card)`
    height: 100%;
    display: flex;
    flex-direction: column;

    h4 {
        margin-top: 0;
        margin-bottom: 1rem;
        color: ${({ theme }) => theme.colors.textDark};
        font-size: 1.1rem;
        flex-shrink: 0;
    }

    .slots-scroll-area {
        flex-grow: 1;
        overflow-y: auto;
        padding-right: 0.5rem;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }
    li {
        background-color: ${({ theme }) => theme.colors.neutralLight};
        padding: 0.5rem 0.75rem;
        border-radius: 6px;
        margin-bottom: 0.5rem;
        font-size: 0.9rem;
        color: ${({ theme }) => theme.colors.textMedium};
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    li button {
        background: transparent;
        border: none;
        color: ${({ theme }) => theme.colors.danger};
        cursor: pointer;
        padding: 0.25rem;
        display: inline-flex;
        align-items: center;
        border-radius: 50%;

        &:hover {
            background-color: ${({ theme }) => theme.colors.dangerBg};
        }

        &:disabled {
            color: ${({ theme }) => theme.colors.textDisabled};
            cursor: not-allowed;
        }
    }
`;

export const AppointmentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const AppointmentCard = styled(Card)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;

    .actions-container {
        display: flex;
        gap: 0.5rem;
        flex-wrap: wrap;
    }

    .cancel-confirm-container {
        width: 100%;
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;

        p {
            font-size: 0.9rem;
            font-weight: 600;
            margin: 0;
        }

        .buttons {
            display: flex;
            gap: 0.5rem;
        }
    }
`;

export const AppointmentDetails = styled.div`
    p {
        margin: 0 0 0.25rem 0;
        color: ${({ theme }) => theme.colors.textMedium};
        strong {
            color: ${({ theme }) => theme.colors.textDark};
        }
        em {
            color: #555;
        }
    }
`;